import { gql } from '@grandvisionhq/graphql';

const productPriceItemFragment = gql`
  fragment productPriceItemFragment on ProductPriceItem {
    priceType
    loyaltyPoints
    originalPrice {
      amount
      currencyCode
    }
    discountedPrice {
      price {
        amount
        currencyCode
      }
      discountInformation {
        type
        value
        description {
          value
          locale
        }
        name {
          value
          locale
        }
      }
    }
  }
`;

export { productPriceItemFragment };
//# sourceMappingURL=productPriceItem.js.map
